import React, { useEffect } from "react";
import "./InsideSacredWalls.css";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const InsideSacredWalls = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="sacred-walls-section" data-aos="fade-up">
      <div className="sacred-walls-header" data-aos="zoom-in">
        <h1>INSIDE THE SACRED WALLS</h1>
        <p>
          Adhie Annan Temple is a sacred place dedicated to Adhie Annan,
          offering rituals, festivals, and community services, spreading
          spirituality and devotion.
        </p>
      </div>

      <div className="sacred-walls-grid">
        <div className="sacred-box image-box" data-aos="fade-up">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-1.png"
            alt="Temple Tower"
          />
        </div>

        <div className="sacred-box red-box" data-aos="fade-down">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-icon-1.png"
            alt="Deity Icon"
            className="icon"
          />
          <p>
            Experience divine presence and spiritual peace with our revered
            deities.
          </p>
          <button onClick={() => navigate("/deities")}>
            Explore Temple Deities
          </button>
        </div>

        <div className="sacred-box image-box" data-aos="fade-up">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-2.png"
            alt="Temple Tower"
          />
        </div>

        <div className="sacred-box red-box" data-aos="fade-down">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-icon-2.png"
            alt="History Icon"
            className="icon"
          />
          <p>A temple with a rich history and deep traditions since 1999.</p>
          <button onClick={() => navigate("/about")}>
            Explore Temple About
          </button>
        </div>

        <div className="sacred-box image-box" data-aos="fade-up">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-3.svg"
            alt="Temple Tower"
          />
        </div>

        <div className="sacred-box red-box" data-aos="fade-down">
          <img
            src="/assets/image/InsideSacredWalls/InsideSacredWalls-icon-3.png"
            alt="Gallery Icon"
            className="icon"
          />
          <p>
            Discover temple beauty. View sacred moments in our photo gallery.
          </p>
          <button onClick={() => navigate("/gallery")}>
            Explore Temple Gallery
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsideSacredWalls;
